<template>
<div class="chapter">
<div class="inner_page">
<p class="C373"><strong><a id="page_19">FISH</a></strong></p><a id="page_19">
<p class="C416">Roughly speaking, there are three kinds of fish: the cartilaginous fish (Chondrichthyes), the jawless fish (Agnatha), and the bony fish (Osteichthyes). Cartilaginous fish are sharks, rays, and chimaeras; jawless fish are things like hagfish and lampreys (which we do not cover in this book); and bony fish are every other fish in the sea. It is probably not necessary to add that bony fish are the largest living class of fish, and indeed the largest living class of vertebrates, with tens of thousands of species.</p>
<p class="C417">The bony fish share several traits, few of which are meaningful to lay people like ourselves. The most important characteristic is the bony skeleton. In some fish, like certain species of puffer, this skeleton has degraded into just a few rounded bones; in others, like the herrings, bones seem to sprout fully formed from every millimeter of flesh. Some massive fish have soft bones (Swordfish), and some have bones hard enough to crack knife blades (Black Drum).</p>
<p class="C417">Sharks and rays, covered later in this book, have soft sinewy bodies buttressed with delicate cartilage skeletons. The biggest shark is easily dismembered with even a small, poorly honed knife; that same knife will slice right through the smaller sharks and rays. We don’t cover chimaeras in this book, as they live deeper than Gulf commercial boats ever fish.</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 10_FISH.vue?3445eb68